import {ImageRequestParams} from "../models/image/image-request-params";
export class LeaveGroupImageRequestParams extends ImageRequestParams {
  constructor(width: Number, height: Number) {
    super({width, height});

    this._resourceName = `bolao24/Icons/Leave_Group_Icon`;
  }
}
